import { useEffect, useState } from 'react';
import { describeLoadFailure, jsonOrThrow } from './apiJson';

export function useLandingCategories() {
  const [categories, setCategories] = useState([]);
  const [comingSoonCategories, setComingSoonCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [categoriesError, setCategoriesError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch('/api/landing-categories.php')
      .then((res) => jsonOrThrow(res))
      .then((data) => {
        if (!cancelled) {
          setCategories(Array.isArray(data?.categories) ? data.categories : []);
          setComingSoonCategories(
            Array.isArray(data?.comingSoonCategories)
              ? data.comingSoonCategories
              : [],
          );
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setCategoriesError(describeLoadFailure(e));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setCategoriesLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    categories,
    comingSoonCategories,
    categoriesLoading,
    categoriesError,
  };
}
